<script lang="ts">
  import { Hospital } from '../lib/api';
  import BedSemaphoreGrid, { type SemaforoData } from './dashboard/widgets/BedSemaphoreGrid.svelte';

  let data = $state<SemaforoData | null>(null);
  let error = $state<string | null>(null);

  async function cargar() {
    try { data = await Hospital.semaforo(); error = null; }
    catch (e: any) { error = e?.message; }
  }
  $effect(() => { cargar(); const t = setInterval(cargar, 30000); return () => clearInterval(t); });
</script>

<section>
  <header class="view-header">
    <div><h2>Semáforo de camas</h2><p class="muted">Estado de ocupación de camas en tiempo real</p></div>
    <button type="button" onclick={cargar}>Recargar</button>
  </header>
  {#if error}<p class="err">⚠ {error}</p>{/if}
  <BedSemaphoreGrid {data} showTables={true} />
</section>

<style>
  .view-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem; }
  .view-header h2 { margin: 0; font-size: 1.4rem; color: #111827; }
  .muted { margin: 0.2rem 0 0; color: #6b7280; font-size: 0.85rem; }
  button { padding: 0.5rem 0.9rem; border: 0; background: linear-gradient(135deg, #15803d, #16a34a); color: #fff; border-radius: 8px; cursor: pointer; font: inherit; font-weight: 600; box-shadow: 0 4px 14px rgba(22,163,74,0.3); transition: transform 0.15s; }
  button:hover { transform: translateY(-1px); }
  .err { color: #dc2626; }
</style>
